import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AngularFireAuth } from '@angular/fire/auth';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-password-reset-page',
  templateUrl: './password-reset-page.component.html',
  styleUrls: ['./password-reset-page.component.scss']
})
export class PasswordResetPageComponent implements OnInit {
  submitted = false;
  submitError = false;
  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  constructor(private auth: AngularFireAuth, private route: ActivatedRoute) {}

  async ngOnInit() {}

  async sendResetMail() {
    if (!this.form.valid) {
      return;
    }
    const email = this.form.value.email;
    try {
      await this.auth.auth.sendPasswordResetEmail(email);
      this.submitted = true;
    } catch (e) {
      // alert(e);
      this.submitError = true;
    }
  }
}
